const approvedStyle = { borderColor: '#EC2121', color: '#EC2121' }

export default {
  approvedStyle
}
